import { Box, Flex } from '@chakra-ui/react';
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterIcon, TwitterShareButton, generateShareIcon } from 'react-share';

const generateShareUrl = () => {
    // You can create a share URL specific to your application
    //const groupUrl = `https://pindogo.com/groups/${updatedGroup.id}`;
    const groupUrl = `https://pindogo.com/groups`;
  
    return groupUrl;
  };
  

const GroupShareButton = () => {

  //const { FacebookShareButton, TwitterShareButton, LinkedinShareButton } = ShareButtons;
  const shareUrl = generateShareUrl();
  //const title = `Check out this group on MyApp: ${updatedGroup?.name}`;
  const title = `Check out this group on MyApp:`;

  return (
    <>

    
      <Box>
        <FacebookShareButton url={shareUrl} quote={title}>
            <FacebookIcon size={32} round />
        </FacebookShareButton>
      </Box>
      
      <Box>
        <TwitterShareButton url={shareUrl} title={title}>
            <TwitterIcon size={32} round />
        </TwitterShareButton>
      </Box>

      <Box>
        <LinkedinShareButton url={shareUrl} title={title}>
            <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </Box>
    

    </>
    
  );
};

export default GroupShareButton
